import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { Master } from '@providers/asset/index';

@Component({
  selector: 'page-about',
  templateUrl: 'page.html'
})
export class AboutPage {

  content:any;
  loading:any;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public masterApi: Master
  ) {
    
  }

  ionViewDidEnter() {
    this.getContent();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getContent();
  }
 
  getContent(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.masterApi.getAbout().subscribe((resp:any) => {
      this.content = resp.about;
      loading.dismiss();
      console.log(this.content);
    },(err) => {
      loading.dismiss();
    });
    
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/asset/about/page.ts